var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inventory container-fluid"},[_c('div',{staticClass:"row"},[_c('Menu',{attrs:{"title":"Inventory"}}),_c('Inventory',{attrs:{"id":"inventory_view"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }